import { render, staticRenderFns } from "./ConfigurePassword.vue?vue&type=template&id=007ab47a&"
import script from "./ConfigurePassword.vue?vue&type=script&lang=js&"
export * from "./ConfigurePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports